import React, { ReactNode, ReactElement } from 'react'
import { HiOutlineMinus } from 'react-icons/hi2'
import classNames from 'classnames'

export const Breadcrumbs = ({
  className,
  children,
}: {
  className?: string
  children: ReactNode
}) => {
  const breadcrumbItems = React.Children.toArray(children) as ReactElement[]

  return (
    <nav
      className={classNames(
        'w-full relative bg-white min-h-9 @container',
        className
      )}
      aria-label="Breadcrumb"
    >
      <ol className={`hidden @[800px]:flex items-start w-min h-full`}>
        {breadcrumbItems.map((child: ReactElement, index) => {
          const isLastItem = breadcrumbItems.length - 1 === index
          return React.cloneElement(child, {
            isLastItem,
          })
        })}
      </ol>

      <ol className="hidden @[420px]:flex @[800px]:hidden items-start w-min h-full max-w-[100%] overflow-hidden">
        {React.cloneElement(breadcrumbItems.at(-2) as ReactElement)}
        {React.cloneElement(breadcrumbItems.at(-1) as ReactElement, {
          className: 'max-w-fit overflow-auto',
          linkClassName: 'truncate',
          isLastItem: true,
        })}
      </ol>

      <ol className="flex @[420px]:hidden items-start w-full h-full">
        {React.cloneElement(breadcrumbItems.at(-2) as ReactElement, {
          text: 'Back',
        })}
        {React.cloneElement(breadcrumbItems.at(-1) as ReactElement, {
          isLastItem: true,
          className: 'max-w-fit overflow-auto',
          linkClassName: 'truncate',
        })}
      </ol>
    </nav>
  )
}

interface IBreadcrumbItem {
  href?: string
  text: string
  isLastItem?: boolean
  className?: string
  linkClassName?: string
}

export const BreadcrumbsItem = ({
  href,
  text,
  isLastItem = false,
  className,
  linkClassName,
}: IBreadcrumbItem) => {
  return (
    <li
      className={`flex items-start text-xl text-black font-mori leading-9 ${className}`}
    >
      <a
        href={href}
        className={`!mb-0 text-black break-keep whitespace-nowrap select-none pb-[1.5px] hover:pb-0 hover:border-b-[1.5px] leading-tight border-black-80 ${
          isLastItem ? 'text-black-80 font-medium pointer-events-none' : ''
        } ${linkClassName}`}
        aria-current={isLastItem ? 'page' : undefined}
      >
        {text}
      </a>
      {!isLastItem && (
        <HiOutlineMinus className="w-8 h-5 mx-1 mt-1 text-black" />
      )}
    </li>
  )
}
